import { SsoIdentifierTypes } from 'src/types/Corp';
import { EmployeeFormFields } from 'src/components/enterprise/features/Employee/components/Form/types/EmployeeForm';

export function getSsoValueFromEmployeeFields(
  corpSsoIdentifier: SsoIdentifierTypes,
  values: EmployeeFormFields
): string | undefined {
  switch (corpSsoIdentifier) {
    case SsoIdentifierTypes.INTERNAL_ID:
      return values.internalId;
    case SsoIdentifierTypes.EMAIL:
      return values.email;
    case SsoIdentifierTypes.OTHER:
    default:
      return values.corpDinerSettings?.ssoUniqueIdentifier;
  }
}

export function transformSsoIdentifierUIToModel(
  corpSsoIdentifier: SsoIdentifierTypes
) {
  return (values: EmployeeFormFields): EmployeeFormFields => {
    const newSsoValue = getSsoValueFromEmployeeFields(
      corpSsoIdentifier,
      values
    );

    return {
      ...values,
      corpDinerSettings: {
        ...values.corpDinerSettings,
        ssoUniqueIdentifier: newSsoValue,
      },
    };
  };
}
